module.exports = __webpack_public_path__ + "img/132.04653294.png";